import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/customers/orders/items'

const CustomerOrderItemsApiV2 = {

  /**
   * Get list of `Order Item with productable type scraper product`
   * @param {object} params uri parameter
   * @return {object} Collection of `Merchant`
   */
  getScrapers: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = `${API_PATH}/scrapers`

    const response = axios.get(path, { params })
    return response
  }

}

export default CustomerOrderItemsApiV2
